import ApiService from '@/services/api';

import { TSeatDirection, seatsEndpoint, seatsField } from './change-license-seats';

// TYPES

export type TPreviewLicenseSeatsMaterials = {
  companyId: number;
  seats: number;
  direction: TSeatDirection;
};

export type TPreviewLicenseSeatsResponse = {
  /** Signed: positive when seats are bought, negative when they are given back. */
  seats: number;
  /** Amounts in the smallest currency unit: 79970 means EUR 799.70. Negative for a credit. */
  net_amount: number;
  tax_amount: number;
  total_amount: number;
  currency: string;
};

/**
 * What the change would cost or credit right now - nothing is changed.
 *
 * The amount is Stripe's, not a multiplication of the yearly rate: a change
 * mid-year credits the unused time on the current seats and charges the rest
 * of the year for the new count.
 */
export const previewLicenseSeats = async ({
  companyId,
  seats,
  direction,
}: TPreviewLicenseSeatsMaterials): Promise<TPreviewLicenseSeatsResponse> => {
  const endpoint = `${seatsEndpoint(companyId, direction)}preview/`;
  const response = await ApiService.get(endpoint, { params: { [seatsField(direction)]: seats } });
  return response?.data;
};
